export namespace Analytics {
  export const propertyId = 'G-WKLFBCB0D8'

  export const disable = () => {
    window[`ga-disable-${propertyId}`] = true
  }
}
